import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import AttachmentList from "./AttachmentList";
import config from "../../config/config";
import axios from 'axios';
import {styles} from '../CSS/Styles'
import moment from 'moment';
import setting from "../../config/setting";

class RecipeReviewCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.getRiskDetail = this.getRiskDetail.bind(this);


    }
    componentDidMount() {
        this.getRiskDetail();
    }

    getRiskDetail() {
        if (this.props.riskname == null || this.props.riskname == '') {
            this.setState({

            });
        } else {
            axios.get(config.rrattachment + '/' + this.props.riskname).then(res => {
                for (let item in res.data) {
                    console.log("datebase time is ")
                    console.log(res.data[item]['update_time'])
                    console.log(moment(res.data[item]['update_time']).format(setting.time_format))
                    res.data[item]['update_time'] = moment(res.data[item]['update_time']).format(setting.time_format)
                }
                let sorted = res.data.sort((a,b)=>{return a>b? 1:-1})
                this.setState({
                    riskExcelList:sorted
                });
                // console.log("attachments")
                // console.log(this.state.metaData.attachments)
            });
        }
    }

    render() {

        const { classes } = this.props;
        const detailsView = (
            <Card className={classes.card_row_expand}>
                <CardContent className={classes.content} >
                    <AttachmentList title={this.props.riskname} risk = {this.state.riskExcelList} />
                </CardContent>
            </Card>
        );
        return (
            <div style={{height:'92%'}}>
                {detailsView}
            </div>
        );
    }
}

RecipeReviewCard.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RecipeReviewCard)


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterRowExpandDetail.js